import { render, staticRenderFns } from "./LabelTextProperties.vue?vue&type=template&id=eafd73c0&scoped=true"
import script from "./LabelTextProperties.vue?vue&type=script&lang=js"
export * from "./LabelTextProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafd73c0",
  null
  
)

export default component.exports